<div class="search-row-block">
    <input type="text" [(ngModel)]="searchQuery" class="searchInput" placeholder="Search" />
    <div class="search-icon"></div>
</div>
<div style="max-height: 20.5rem; overflow:auto;margin-top:0.5rem">
    <div *ngFor="let item of input | search : searchQuery : ['data'];let i = index" class="values" (click)="selectedOption(item)" [ngClass]="{'clickedDiv': item.isSelected}">
        <div class="checkboxDiv"><input type="checkbox" class="searchCheckbox" [checked]="item.isSelected"></div>
        <div class="itemData" title="{{item.data}}">{{item.data}}</div>
    </div>
</div>